import { Injectable } from '@angular/core';
import { DashboardFilters } from './dashboard-filters.model';
import { Observable ,  ReplaySubject, Subscription } from 'rxjs';
import * as moment from 'moment';
import { PayrollCycleType } from '../../../services/payroll-types.service';
import { FeatureToggleService } from '../../../shared/services/feature-toggle/feature-toggle.service';
import { Util } from '../../../../util';
import { PayrollScheduleService } from '../../../services/payroll-schedule.service';
import { PayrollSchedule } from '../../../services/payroll-schedule.model';

@Injectable()
export class FiltersService {
  private subject: ReplaySubject<DashboardFilters>;

  constructor(private _featureToggleService: FeatureToggleService, private _payrollScheduleService: PayrollScheduleService) {
    this.subject = new ReplaySubject<DashboardFilters>(1);

    if (this._featureToggleService.isFeatureEnabled('enableDefaultPayDate')) {
      this._payrollScheduleService.getPayrollSchedule().subscribe(schedule => {
        const newFilters = this.createDefaultFilter();
        if (schedule) {
          schedule = new PayrollSchedule(schedule);
          const defaultDate = schedule.getDefaultPayrollDate();
          newFilters.payDate = defaultDate;
        }
        this.updateFilters(newFilters);
      });
    } else {
      this.updateFilters(this.createDefaultFilter());
    }
  }

  updateFilters(filters: DashboardFilters) {
    this.subject.next(filters);
  }

  clearFilters() {
    this.subject.next(this.createDefaultFilter());
  }

  getFilters(): Observable<DashboardFilters> {
    return this.subject.asObservable();
  }

  createDefaultFilter(): DashboardFilters {
    return new DashboardFilters(
      Util.MIN_DATE,
      PayrollCycleType.All,
      []
    );
  }

}
